var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "btn flex-column flex-lg-row btn-close",
    attrs: {
      "type": "button"
    }
  }, [_c('mdm-icon', {
    staticClass: "icon mb-1 mx-auto mb-lg-0 order-lg-2 close-icon",
    attrs: {
      "size": "20",
      "name": "cross"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'close',
      expression: "'close'"
    }],
    staticClass: "text-uppercase pr-lg-2 order-lg-1 close-text"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };